module.exports = __webpack_public_path__ + "static/media/ful stack.ef9f8428.png";